



































import mixins from 'vue-typed-mixins';
import moment from 'moment';
import { AutomatedEmailParams } from '@/utils/EmailUtils';
import ProviderUtils, { ServiceProvider } from '@/utils/ProviderUtils';
import { DataTableHeader } from 'vuetify';
import SurveyUtils, { SurveyParticipation } from '../../../utils/SurveyUtils';

interface ProviderEmailTableItem {
  id: number;
  provider: ServiceProvider;
  participations: SurveyParticipation[];
}

export default mixins().extend({
  props: {
    value: {
      type: Object as () => AutomatedEmailParams,
    },
  },

  computed: {
    providers: {
      get(): ProviderEmailTableItem[] {
        this.$emit(
          'validate',
          (this.value.serviceproviders &&
            this.value.serviceproviders?.length > 0) ||
            false
        );
        return this.value.serviceproviders?.map((provider) =>
          this.filteredItems?.find((item) => provider.id === item.provider.id)
        ) as any;
      },
      set(items: ProviderEmailTableItem[]) {
        this.value.serviceproviders = items?.map((item) => item.provider);
      },
    },

    filteredItems(): ProviderEmailTableItem[] | undefined {
      return this.items?.filter((item) => {
        if (
          this.value.surveygroup ||
          (this.value.surveys && this.value.surveys.length > 0)
        ) {
          return item.participations.length > 0;
        } else {
          return true;
        }
      });
    },

    headers(): DataTableHeader<ServiceProvider>[] {
      return [
        { text: this.$i18n.tc('model.common.name'), value: 'provider.name' },
        {
          text: this.$tc('model.oversightOrganization.label'),
          value: 'provider.parent.name',
        },
        {
          text: this.$tc('model.common.type'),
          value: 'provider.serviceprovidertype.name',
        },
        {
          text: this.$tc('model.survey.label', 2),
          value: 'participations',
        },
      ];
    },
  },

  data(): {
    items?: ProviderEmailTableItem[];
  } {
    return {
      items: undefined,
    };
  },

  async mounted() {
    try {
      this.items = undefined;

      const resp = await Promise.all([
        ProviderUtils.api.instance.list(),
        Promise.all(this.loadParticipations()),
      ]);

      const participations = resp[1].reduce((participations, result) => {
        return result.concat(participations);
      }, []);

      this.items = resp[0]?.map((provider) => ({
        id: provider.id as number,
        provider: provider,
        participations: participations
          ?.filter(
            (participation) => participation.serviceprovider.id === provider.id
          )
          .sort((a, b) => {
            const aCreatedDate = moment(a.createddate);
            const bCreatedDate = moment(b.createddate);
            if (aCreatedDate.isBefore(bCreatedDate)) {
              return 1;
            } else if (aCreatedDate.isAfter(b.createddate)) {
              return -1;
            } else {
              return 0;
            }
          }),
      }));
    } catch (error) {
      this.$alert.show('mount', {
        type: 'error',
        messages: this.$handleAPIError(error),
      });
    }
  },

  methods: {
    loadParticipations() {
      if (this.value.surveys && this.value.surveys.length > 0) {
        return this.value.surveys?.map((survey) =>
          SurveyUtils.api.surveyParticipation.list({
            surveygroupid: this.value.surveygroup?.id,
            surveyid: survey?.id,
          })
        );
      } else {
        return [
          SurveyUtils.api.surveyParticipation.list({
            surveygroupid: this.value.surveygroup?.id,
          }),
        ];
      }
    },
  },
});
